import { Component, Input, OnInit } from '@angular/core';
// @ts-ignore
import ApexCharts  from 'apexcharts';
import { SolardashboardService } from 'src/app/services/solardashboard.service';
import Swal from 'sweetalert2';
interface CalendarKwhData {
  date: any; // YYYY-MM-DD format
  kwh: any;
}
@Component({
  selector: 'app-solardashboard',
  templateUrl: './solardashboard.component.html',
  styleUrls: ['./solardashboard.component.scss']
})
export class SolardashboardComponent implements OnInit {
  @Input() kwhDatas: CalendarKwhData[] = [];

  currentYear!: number;
  currentMonth!: number;

  monthName!: string;
  daysInMonth!: number;
  startWeekDay!: number;

  selectedMonth: 'this' | 'last' = 'this';
  cost: number = 7;
  calculatedValue: number = 0;
  
  // This is the array used for rendering calendar day cells
  calendarDays: Array<{ day: number | null; kwh?: number; colorClass?: string }> = [];
  generationStats = [
    { value: '0000', label: 'This_Month' },
    { value: '0000', label: 'Last_Month' },
   
    { value: '0000', label: 'Today' },
    { value: '0000', label: 'Yesterday' },
   // { value: '0000', label: 'This_Week' },
  ];
  selectedDuration: string = 'Today';
durationOptions: string[] = [
  'Today',
  'Yesterday',
  'This Week',
  'This Month',
  'Last Month'
];
assetsData = [];

 unitPrice = 7;
selectedTab = 0;
totalPrice = 0;

tabOptions = [
  { label: 'Today', labelShort: 'T' },
  { label: 'Yesterday', labelShort: 'Y' },
  { label: 'This Week', labelShort: 'W' },
  { label: 'This Month', labelShort: 'M' },
  { label: 'Last Month', labelShort: 'LM' }
];

kwhData = {
  0: 12,
  1: 18,
  2: 140,
  3: 530,
  4: 640
};
  assetIDList: any = [];
  generation: any;
  expectedData: any = 0;
  actualData: any;
  loss: any = 0;
  co2Data= { co2Kg: 0, treesPlanted: 0, milesOffset: 0, homesPowered: 0 };
  generationgraphObject: any;
  weatherData: any;
  connected: any = 0;
  disconnected: any = 0;

get currentKwh(): number {
  return this.kwhData[this.selectedTab] || 0;
}

  constructor(private solarService:SolardashboardService) { }

  ngOnInit() {
    const today = new Date();
    this.currentYear = today.getFullYear();
    this.currentMonth = today.getMonth();
    this.getAssetId();
    this.getWeather();
  }

  consumptionBarChart(){
    var options = {
      series: [{
        name: "Daily",
        data: [0]
      }],
      chart: {
        type: 'bar',
        height: '100%',
        toolbar: {
          show: true,
          tools: {
            download: true // <-- this enables SVG, PNG, CSV
          }
        },
        events: {
          legendClick: (chartContext, seriesIndex) => {
            const legendName = options.series[seriesIndex].name;
            // Optional: trigger popup
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        }
      },
      colors: ["#008000", "#808080"],
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: [0],
        labels: {
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        title: {
          text: 'Consumption'
        }
      },
      fill: {
        opacity: 1,
        type: "gradient"
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return `${val} Kwh`
          }
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right'
      },
      grid: {
        show: false
      }
    };
    
    this.generationgraphObject = new ApexCharts(document.querySelector("#barChart"), options);
    this.generationgraphObject.render();    
  }
  deviceStatus(connected,disconnected){
   const seriesData = [connected,disconnected]; 
     var options = {
       series: seriesData,
       chart: {
         height: "100%",
         type: 'pie',
         events: {
           legendClick: (chartContext, seriesIndex) => {
             const legendName = options.labels[seriesIndex];
             //this.popupTable(legendName, this.deviceConnectionStatus);
           }
         },
       },
       
       colors:["#008000","#808080"],
       labels: ["Connected", "Disconnected"], 
       dataLabels: {
         enabled: false,
       },
       fill: {
         type: 'gradient',
       },
       legend: {
         position: 'right',
         formatter: function (val, opts) {
          // Add the image only for "disconnected" legend item
          if (val.toLowerCase() === "disconnected") {
            return `<span style="font-weight: bolder; cursor: pointer;">
              ${val} :<b style="font-size:2vh;"> ${opts.w.globals.series[opts.seriesIndex]}</b><br>
              
            </span>`;
          }
          return `<span style="font-weight: bolder; cursor: pointer;">
            ${val} :<b style="font-size:2vh;"> ${opts.w.globals.series[opts.seriesIndex]}</b>
          </span>`;
        },
        labels: {
          useSeriesColors: true, 
        },
       },
     /*  title: {
         text: 'Connection Status',
         align: 'center',
         style:{
          //color:this.textColor
        }
       },*/
      
     };
  
     var chart = new ApexCharts(document.querySelector("#deviceStatus"),options);
     chart.render();
  }
  performanceDegradationChart(performanceData){
    const seriesData = performanceData.map(d => d.performance_change_percent);
    const categories = performanceData.map(d => d.month);

    // Generate per-point marker colors
    const markerColors = performanceData.map(d => (d.status == 'improved' ? '#00c49f' : '#f44336')); // green / red
    const discreteMarkers = performanceData.map((d, i) => ({
      seriesIndex: 0,
      dataPointIndex: i,
      fillColor: d.status === 'improved' ? '#00c49f' : '#f44336', // green or red
      strokeColor: d.status === 'improved' ? '#00c49f' : '#f44336',
      size: 6
    }));
    const performanceDegradationChartOptions = {
      series: [{
        name: 'Performance',
        data: seriesData
      }],
      chart: {
        type: 'line',
        height: '100%',
        toolbar: { show: false },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: { enabled: true, delay: 150 },
          dynamicAnimation: { enabled: true, speed: 350 }
        }
      },
      stroke: {
        curve: 'smooth',
        width: 3,
        colors: ['#00c49f']
      },
      markers: {
        size: 5,
        discrete: discreteMarkers,
        hover: {
          size: 8
        }
      },
      xaxis: {
        categories: categories,
        title: {
          text: 'Month',
          style: { fontSize: '14px', color: '#888' }
        },
        labels: {
          style: { fontSize: '12px', colors: '#555' }
        }
      },
      yaxis: {
        title: {
          text: 'Change (%)',
          style: { fontSize: '14px', color: '#888' }
        },
        labels: {
          formatter: val => `${val.toFixed(1)}%`,
          style: { fontSize: '12px', colors: '#555' }
        }
      },
      tooltip: {
        theme: 'light',
        y: {
          formatter: val => `${val.toFixed(2)}%`
        }
      },
      grid: {
        borderColor: '#e0e0e0',
        strokeDashArray: 4,
        padding: { left: 10, right: 10, bottom: 0 }
      },
      responsive: [
        {
          breakpoint: 600,
          options: {
            chart: { height: 300 },
            xaxis: {
              labels: { rotate: -45 }
            }
          }
        }
      ]
    };
    // Render the chart
    const chart = new ApexCharts(document.querySelector("#performanceDegradation"), performanceDegradationChartOptions);
    chart.render();

  }

  getAssetId(){
    this.solarService.getSolarAssetId(JSON.parse(localStorage.getItem('userData'))).subscribe(res=>{
      if(res.status){
        this.assetIDList = res.data.map(element=> element.serialNo);
        console.log("adsda",this.assetIDList)
        this.consumptionBarChart();
        this.generationGraphDaily(this.assetIDList)
        this.performanceDegradation(this.assetIDList);
        this.renderCalendar();
        this.getDeviceStatus(this.assetIDList)
        this.solarService.getGeneration({assetids:this.assetIDList}).subscribe(resp=>{
          if(resp.status){
            this.generationStats = this.generationStats.map(stat => ({
              ...stat,
              value: resp.data[stat.label] !== undefined
                ? resp.data[stat.label].toFixed(2)
                : '0000'
            }));
            this.solarService.getGenerationPerAsset({assetids:this.assetIDList}).subscribe(response=>{
              if(response.status){
                this.assetsData = response.data;
               // this.selectDuration("Today")
                const totalLoggedSum = response.data.reduce((sum, item) => sum + (Number(item.Total_Logged_KWH) || 0), 0);
                  this.generationStats.forEach(item => {
                    if (item.label == 'Total_Logged') {
                      item.value = totalLoggedSum.toFixed(2);
                    }
                  });
                  this.EO2Emission();
              }
            })
            this.calculate()
          } else{
            Swal.fire({
              title: 'Error!',
              text: resp.message,
              icon: 'error',
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              backdrop: true
            });   
          }
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: res.message,
          icon: 'error',
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          backdrop: true
        });        
      }
    })
  }
getDeviceStatus(data){
  this.solarService.getDeviceStatus({assetid:data}).subscribe(res=>{
    if(res.status){
      console.log("what is count",res.data)
      let connected = res.data.length;
      let disconnected = this.assetIDList.length - res.data.length;
      this.deviceStatus(connected,disconnected);
    }
  });
}

  selectedFilter: string = 'daily';

onFilterSelect(filter: string) {
  this.selectedFilter = filter;
  if(filter == 'daily'){
    this.generationGraphDaily(this.assetIDList);
  } else if(filter == 'weekly'){
    this.generationGraphWeekly(this.assetIDList);
  } else if(filter == "monthly"){
    this.generationGraphMonthly(this.assetIDList)
  }
  
  // You can also trigger chart updates here
  console.log('Filter selected:', filter);
}
selectedFilterPerformance : string ='daily';
onFilterSelecPerformancet(filter: string) {
  this.selectedFilterPerformance = filter;

  // You can also trigger chart updates here
  console.log('Filter selected:', filter);
}
selectDuration(option: string) {
  this.selectedDuration = option;
  if(option == "Today"){
    this.expectedData = this.assetsData.reduce((sum, item) => sum + (Number(item.Expected_Today_KWH) || 0), 0);
    this.actualData = this.generationStats.find(resp=>resp.label == "Today").value;
    this.loss = Number(this.expectedData - this.actualData).toFixed(2);
  } else  if(option == "Yesterday"){
    this.expectedData = this.assetsData.reduce((sum, item) => sum + (Number(item.Expected_Yesterday_KWH) || 0), 0);
    this.actualData = this.generationStats.find(resp=>resp.label == "Yesterday").value;
    this.loss = Number(this.expectedData - this.actualData).toFixed(2);
  } else  if(option == "This Week"){
    this.expectedData = this.assetsData.reduce((sum, item) => sum + (Number(item.Expected_This_Week_KWH) || 0), 0);
    this.actualData = this.generationStats.find(resp=>resp.label == "This_Week").value;
    this.loss = Number(this.expectedData - this.actualData).toFixed(2);
  } else  if(option == "This Month"){
    this.expectedData = this.assetsData.reduce((sum, item) => sum + (Number(item.Expected_This_Month_KWH) || 0), 0);
    this.actualData = this.generationStats.find(resp=>resp.label == "This_Month").value;
    this.loss = Number(this.expectedData - this.actualData).toFixed(2);
  } else  if(option == "Last Month"){
    this.expectedData = this.assetsData.reduce((sum, item) => sum + (Number(item.Expected_Last_Month_KWH) || 0), 0);
    this.actualData = this.generationStats.find(resp=>resp.label == "Last_Month").value;
    this.loss = Number(this.expectedData - this.actualData).toFixed(2);
  }
  
}
calculateTotal(): void {
  const units = this.currentKwh / 1000;
  this.totalPrice = units * this.unitPrice;
}

onTabChange(event: any): void {
  this.selectedTab = event.value;
  this.calculateTotal();
}
EO2Emission(){
  let kwh:any = 0;
  let CO2_PER_KWH = 0.417;
  let TREE_CO2_ABSORPTION = 21;
  let CO2_PER_CAR_MILE = 0.404;
  let KWH_PER_HOME = 10715;
  this.generationStats.forEach(item => {
    if (item.label == 'This_Month') {
      kwh =  item.value 
    }
  });
  let co2Kg = Number(kwh) * Number(CO2_PER_KWH);
 let treesPlanted = Number(co2Kg) / Number(TREE_CO2_ABSORPTION);
  let milesOffset = Number(co2Kg) / Number(CO2_PER_CAR_MILE);
  let homesPowered = Number(kwh) / Number(KWH_PER_HOME);
  this.co2Data = {co2Kg:co2Kg,treesPlanted:treesPlanted,milesOffset:milesOffset,homesPowered:homesPowered};
}
generationGraphDaily(data){
  this.solarService.generationGraph({assetid:data}).subscribe(resp=>{
      if(resp.status){
        const categories = resp.data.map(item => item.day);
        const dataSeries = resp.data.map(item => parseFloat(item.total_kwh.toFixed(2)));
        this.generationgraphObject.updateOptions({
          xaxis: {
            categories: categories,
            title: {
              text: 'Date'
            }
          },
          yaxis: {
            title: {
              text: 'Total kWh'
            }
          },
          series: [
            {
              name: 'kWh',
              data: dataSeries
            }
          ],
          title: {
            text: `${this.selectedFilter} Generation kWh`,
            align: 'center'
          }
        });
      }
  })

}
generationGraphWeekly(data){
  this.solarService.generationGraphWeekly({assetid:data}).subscribe(resp=>{
      if(resp.status){
        console.log("ererr",resp)
        const categories = resp.data.map(item => item.week_range);
        const dataSeries = resp.data.map(item => parseFloat(item.total_kwh).toFixed(2));
        console.log("asdasdassad",categories)
        this.generationgraphObject.updateOptions({
          xaxis: {
            categories: categories,
            title: {
              text: 'Date'
            }
          },
          yaxis: {
            title: {
              text: 'Total kWh'
            }
          },
          series: [
            {
              name: 'kWh',
              data: dataSeries
            }
          ],
          title: {
            text: `${this.selectedFilter} Generation kWh)`,
            align: 'center'
          }
        });
      }
  })

}

performanceDegradation(data){
  console.log("IN Performance Degradation ")
  this.solarService.generationGraphMonthly({assetid:data}).subscribe(resp=>{
    if(resp.status){
      const degradation = [];
      let lastValid = null;

      for (let i = 0; i < resp.data.length; i++) {
        const month = resp.data[i].month;
        const kwh = parseFloat(resp.data[i].total_kwh);

        if (kwh > 0 && lastValid !== null) {
          const percentChange = ((kwh - lastValid.kwh) / lastValid.kwh) * 100;
          const status = percentChange < 0 ? 'degraded' : 'improved';

          degradation.push({
            month,
            current_kwh: kwh,
            previous_kwh: lastValid.kwh,
            performance_change_percent: parseFloat(percentChange.toFixed(2)),
            status: status
          });

          console.log("Performance Change Data", degradation);

          lastValid = { month, kwh };
        } else if (kwh > 0) {
          lastValid = { month, kwh };
        }
      }
      this.performanceDegradationChart(degradation);
  }
  });
}
generationGraphMonthly(data){
  this.solarService.generationGraphMonthly({assetid:data}).subscribe(resp=>{
      if(resp.status){
        const categories = resp.data.map(item => item.month);
        const dataSeries = resp.data.map(item => parseFloat(item.total_kwh).toFixed(2));
        this.generationgraphObject.updateOptions({
          xaxis: {
            categories: categories,
            title: {
              text: 'Date'
            }
          },
          yaxis: {
            title: {
              text: 'Total kWh'
            }
          },
          series: [
            {
              name: 'kWh',
              data: dataSeries
            }
          ],
          title: {
            text: `${this.selectedFilter} Generation kWh)`,
            align: 'center'
          }
        });
      }
  })
}
getWeather(){
  this.solarService.getWeatherData(JSON.parse(localStorage.getItem('userData'))).subscribe(resp=>{
    console.log("weatherData",resp.data)
    if(resp.status){
      this.weatherData = resp.data;
    }
  })
}
private getMonthName(monthIndex: number): string {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  return months[monthIndex];
}

renderCalendar() {
  this.solarService.getCalenderData({assetid:this.assetIDList}).subscribe(response =>{
    if(response.status){
      this.kwhDatas = response.data;
  this.monthName = this.getMonthName(this.currentMonth);
console.log("asdasdasd curret month",this.currentMonth,this.monthName)
  const firstDay = new Date(this.currentYear, this.currentMonth, 1);
  const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);
  this.daysInMonth = lastDay.getDate();
  this.startWeekDay = firstDay.getDay();

  this.calendarDays = [];

  // Add empty cells before the first day
  for (let i = 0; i < this.startWeekDay; i++) {
    this.calendarDays.push({ day: null });
  }
  console.log("is KWH Found ",firstDay)

  // Add days with kWh info if available
  for (let day = 1; day <= this.daysInMonth; day++) {
    const dateStr = new Date(this.currentYear, this.currentMonth, day).toLocaleDateString('en-CA').slice(0, 10);
    const kwhEntry = this.kwhDatas.find(entry => entry.date == dateStr);
    let colorClass = '';
    if (kwhEntry) {
      if (kwhEntry.kwh >= 6) colorClass = 'bg-high';
      else if (kwhEntry.kwh >= 3) colorClass = 'bg-medium';
      else if (kwhEntry.kwh > 0) colorClass = 'bg-low';
    }
//console.log("this are dayt",day, kwhEntry ? kwhEntry : undefined,dateStr,this.daysInMonth)
    this.calendarDays.push({
      day,
      kwh: kwhEntry ? kwhEntry.kwh : undefined,
      colorClass
    });
  }
}
});
}

prevMonth() {
  if (this.currentMonth === 0) {
    this.currentMonth = 11;
    this.currentYear--;
  } else {
    this.currentMonth--;
  }
  this.renderCalendar();
}

nextMonth() {
  if (this.currentMonth === 11) {
    this.currentMonth = 0;
    this.currentYear++;
  } else {
    this.currentMonth++;
  }
  this.renderCalendar();
}
setMonth(type: 'this' | 'last') {
  this.selectedMonth = type;
  this.calculate();
}
calculate() {
  if (this.selectedMonth === 'this') {
    this.calculatedValue = Math.round(this.cost * Number(this.generationStats.find(resp=>resp.label == "This_Month").value));
  } else {
    this.calculatedValue = Math.round(this.cost * Number(this.generationStats.find(resp=>resp.label == "Last_Month").value));
  }
}
}